

import React, { useState, useEffect } from 'react';
import { getIcons } from '../Constant/Constant';
import Loader from '../Constant/Loader';
import { useLocation } from 'react-router-dom';

const LeadStatusFilter = ({ leadCount, onLeadSelect,id }) => {
  const icons = getIcons();
const [loading, setLoading] = useState(false)



  const leadsData = [
    { id: "L0CTrn0qwWlHWvq2gXDm", key: "New", label: "Fresh", icon: icons.freshIcon },
    { id: "Auf9SQFhiKF7WRM9ZiTA", key: "Follow-up", label: "Follow-up", icon: icons.interestedIcon },
    { id: "gJxbL16EjFbzDFCoQU5G", key: "Dealing", label: "Dealing", icon: icons.dealingIcon },
    { id: "znvixWClH1PDoCXO4Aat", key: "Registered Client", label: "Registered Client", icon: icons.customerIcon },
    { id: "8337Bve50LqwfrkveUrY", key: "Deal Lost", label: "Deal Lost", icon: icons.dealLostIcon },


    { id: "PdCEXW0VIoVviuqvjdWc", key: "Retry Suitable", label: "Retry Suitable", icon: icons.RetrySuitable },
    { id: "yUuWlPRZEosdOeLzyL0f", key: "Unanswered", label: "Unanswered", icon: icons.unansweredIcon },
    { id: "VH26wB3VgVXBzoBJiqml", key: "Not Interested", label: "Not Interested", icon: icons.notInterestedIcon },
    { id: "9XSuBds8XzEmvVNDr3yr", key: "Junk", label: "Junk", icon: icons.Junk },
  ];
  const [selectedLead, setSelectedLead] = useState(id || leadsData[0].id);
  const [leadCounts, setLeadCounts] = useState({});


  useEffect(() => {
    if (!Array.isArray(leadCount)) {
      console.warn("leadCount is undefined or not an array:", leadCount);
      return;
    }
  
    const newLeadCounts = leadsData.reduce((acc, lead) => {
      const found = leadCount.find(item => item.key === lead.key);
      acc[lead.id] = found ? found.value : 0; 
      return acc;
    }, {});
  
    setLeadCounts(newLeadCounts);
  }, [leadCount]);
  


  const handleSelectedLead = (leadId) => {
    setLoading(true);

    setTimeout(() => {
      setSelectedLead(leadId);
      if (onLeadSelect) {
        onLeadSelect(leadId);
      }
      setLoading(false);
    }, 500);
  };
  return (
    <div className="p-4 w-full shadow-md rounded-md py-4 px-4 h-[680px] bg-white ">
        {loading && <Loader/>}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Choose Leads Status</h2>
      </div>
      <ul className="space-y-3">
        {leadsData.map((lead) => (
          <li
            key={lead.id}
            className={`flex items-center justify-between p-3 rounded-lg cursor-pointer
              ${selectedLead === lead.id ? "bg-green-100 border border-green-500" : "bg-white border border-gray-300"}
            `}
            onClick={() => handleSelectedLead(lead.id)}
          >
            <div className="flex items-center space-x-3">
              <img src={lead.icon} alt="" />
              <span className="font-medium">{lead.label}</span>
              <span className="text-gray-600 font-medium">
                {id ? " " : `(${leadCounts[lead.id]})`}
              </span>
            </div>
            <div className="flex items-center space-x-2 float-right">
              <form>
                <input
                  type="radio"
                  name="lead"
                  checked={selectedLead === lead.id}
                  onChange={() => setSelectedLead(lead.id)}
                  className="form-radio text-green-500 h-4 w-4"
                />
              </form>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LeadStatusFilter;
